// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "7a54709a60c6bb840b262ecaf97d874a02b23533/scripts/" + chunkId + ".js";
};